import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

let initialized = false;

/**
 * Initializes Amplitude + Session Replay exactly once.
 *
 * Must be called as early as possible (app bootstrap) so Session Replay
 * captures the WHOLE session from the very first interaction. Calling it
 * lazily (only on the first tracked event) or after login leaves the start
 * of the session unrecorded.
 *
 * Idempotent: safe to call from multiple places.
 */
export const initAmplitude = () => {
  if (initialized) return;

  // ── Dosen 3.0 cutover ─────────────────────────────────────────────────────
  // The Amplitude project is selected by this env var. On cutover day, point
  // REACT_APP_AMPLITUDE_INIT_KEY at the "Dosen 3.0" project API key (all envs):
  //   - all new events + Session Replays land in Dosen 3.0
  //   - historical data stays in the legacy "Dosen" project (read-only archive)
  // No code change is required — the key is config, not code.
  const apiKey = process.env.REACT_APP_AMPLITUDE_INIT_KEY || '';
  if (!apiKey) return;

  initialized = true;

  // Register Session Replay BEFORE init so it attaches to the session from
  // the first event (Amplitude v2 recommended order). Adding it after init
  // can drop the beginning of the session from the replay.
  const sessionReplayTracking = sessionReplayPlugin({ sampleRate: 1.0 });
  amplitude.add(sessionReplayTracking);

  amplitude.init(apiKey, {
    defaultTracking: {
      sessions: true,
      pageViews: true
    }
  });
};
